import { Helmet } from "react-helmet";
import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Modal, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { groupBy } from "lodash";
import queryString from "query-string";
import Localize from "../../components/Localized/Localize.comp";
import Tabs from "../../components/Tabs/Tabs";
import CompanyInvestments from "./company.investments";
import {
  getCompanyContactsSummaryAction,
  getCompanyDetailAction,
} from "../../actions/company.actions";
import { getEmailHelp, translateRegistryOnView } from "../../libs/utils";
import CompanyContacts from "./company.contacts";
import CompanyBrands from "./company.brands";
import CompanyPitch from "./company.pitch";
import CompanyCrea from "./company.crea";
import _Localize, { l } from "../../libs/localization";
import CompanyFinancial from "./company.financial";
import { getTreeSectorAction } from "../../actions/registry/registry.sector.actions";
import { get } from "../../libs/helpers/ioc";
import CompanyGroup from "./company.group";
import CompanyInvestmentRound from "./company.investment_round";
import { getFeatures } from "../../libs/features";
import "./company.scss";
import usePermissions from "../../hooks/usePermissions";
import CompanyGeneral from "./company.general";
import CompanyHeader from "./company.header";
import CompanyPitchScores from "./company.pitchScores";
import {
  deleteSettingApi,
  editSettingApi,
  getSettingsApi,
  upsertSettingApi,
} from "../../api/settings.api";
import {
  FROM_EMAIL_ALERTS_TYPES_MAP,
  TO_EMAIL_ALERTS_TYPES_MAP,
} from "../../libs/emailAlerts";
import { associationsTagIdCompanyAction } from "../../actions/tag.actions";

const CompanyDetail = (props) => {
  const { match } = props;

  const features = getFeatures();

  const [showDetailTagModal, setShowDetailTagModal] = useState(false);

  const [selectedAlerts, setSelectedAlerts] = useState([]);

  const [companySettings, setCompanySettings] = useState(null);
  const permissions = usePermissions();

  const tabKeys = {
    detail: "_0",
    brands: "_1",
    pitch: "_2",
    crea: "_3",
    group: "_4",
    investmentRounds: "_5",
    financials: "_6",
    nielsen: "_7",
    contacts: "_8",
    pitchScores: "_10",
  };

  useEffect(() => {
    async function load() {
      const res = await getSettingsApi({
        entityType: "company",
        entityId: match.params.id,
      });
      setCompanySettings(res.data);
    }
    if (permissions.emailAlerts && !companySettings) {
      load();
    }
  }, [match.params.id, companySettings, permissions]);

  useEffect(() => {
    if (Array.isArray(companySettings)) {
      const alertsSettings = companySettings.find(
        (s) => s.key === "email-alerts.company",
      )?.data;
      if (!alertsSettings?.events) setSelectedAlerts([]);
      else {
        const arr = [];
        Object.keys(alertsSettings?.events).forEach((key) => {
          if (alertsSettings?.events[key])
            arr.push(FROM_EMAIL_ALERTS_TYPES_MAP[key]);
        });
        setSelectedAlerts(arr);
      }
    }
  }, [companySettings]);

  const prevSelectedAlertsLength = useRef(selectedAlerts.length);

  useEffect(() => {
    function toSettingsObj(alertsArray) {
      const obj = {};
      alertsArray.forEach((a) => {
        obj[TO_EMAIL_ALERTS_TYPES_MAP[a]] = true;
      });
      return obj;
    }
    if (Array.isArray(companySettings)) {
      const alertsSettings = companySettings.find(
        (s) => s.key === "email-alerts.company",
      );
      const arr = [];
      if (alertsSettings?.data) {
        Object.keys(alertsSettings?.data?.events).forEach((key) => {
          if (alertsSettings?.data?.events?.[key])
            arr.push(FROM_EMAIL_ALERTS_TYPES_MAP[key]);
        });
        if (arr.sort().join(",") !== selectedAlerts.sort().join(",")) {
          if (selectedAlerts.length === 0) {
            if (prevSelectedAlertsLength.current > 0) {
              deleteSettingApi({ id: alertsSettings._id });
              setCompanySettings(null);
            }
          } else {
            editSettingApi({
              id: alertsSettings._id,
              data: {
                data: { events: toSettingsObj(selectedAlerts) },
              },
            });
          }
        }
      } else if (selectedAlerts.length > 0) {
        upsertSettingApi({
          key: "email-alerts.company",
          entityType: "company",
          entityId: match.params.id,
          data: { events: toSettingsObj(selectedAlerts) },
        });
      }
    }
    prevSelectedAlertsLength.current = selectedAlerts.length;
  }, [selectedAlerts, match.params.id, companySettings]);

  const [activeTab, setActiveTab] = useState(tabKeys.detail);

  const params = queryString.parse(window.location.search);

  const data = useSelector((state) => state.company.detail.data);
  const schema = useSelector((state) => state.company.detail.schema);
  const sector = useSelector((state) => state.sector.data);
  const dispatch = useDispatch();

  const entity = "company";

  const isAgency = ["AG", "AC"].includes(data?.type);

  useEffect(() => {
    if (match.params.id && match.params.id !== data?._id) {
      dispatch(
        getCompanyDetailAction({ id: match.params.id, countView: true }),
      );
      dispatch(getTreeSectorAction());
      console.log(permissions);
    }
  }, [match.params.id]);

  useEffect(() => {
    if (match.params.id && data) {
      dispatch(getCompanyContactsSummaryAction({ id: match.params.id }));
      if (permissions.favourites) {
        dispatch(
          associationsTagIdCompanyAction({ data: { id: [match.params.id] } }),
        );
      }
    }
  }, [data, permissions.favourites]);

  useEffect(() => {
    if (params.brand && activeTab !== tabKeys.brands) {
      setActiveTab(tabKeys.brands);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.brand]);

  function sectorModal(title) {
    data.sector.map((companySector, companySectorIndex) => {
      sector.map((sectorTree, sectorIndex) => {
        if (sectorTree.children) {
          sectorTree.children.map((childrenSector) => {
            if (childrenSector.children) {
              childrenSector.children.map((c) => {
                if (c._id === companySector._id)
                  data.sector[companySectorIndex].parent =
                    sector[sectorIndex].key;
              });
            }
            if (childrenSector._id === companySector._id)
              data.sector[companySectorIndex].parent = sector[sectorIndex].key;
          });
        }
      });
    });
    const groupedSector = groupBy(data.sector, "parent");
    Modal.info({
      title,
      content: (
        <>
          {Object.keys(groupedSector).map((parent) => {
            const parentObj = sector.find((s) => {
              return s.key === parent;
            });
            return (
              <>
                {parent !== "undefined" && (
                  <p>
                    {parentObj
                      ? translateRegistryOnView(parentObj._id, "Sector") ||
                        parent
                      : parent}
                  </p>
                )}
                {parent !== "undefined" ? (
                  <ul>
                    {groupedSector[parent].map((s) => (
                      <li className="m-1" key={s._id}>
                        {translateRegistryOnView(s._id, "Sector") || s.key}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <>
                    {groupedSector[parent].map((s) => (
                      <li className="m-1" key={s._id}>
                        {translateRegistryOnView(s.key, "Sector")
                          ? translateRegistryOnView(s.key, "Sector")
                          : s.key}
                      </li>
                    ))}
                  </>
                )}
              </>
            );
          })}
        </>
      ),
      width: "800px",
      onOk: () => setShowDetailTagModal(false),
    });
  }

  function info(title, content) {
    Modal.info({
      title,
      content,
      width: "800px",
      onOk: () => setShowDetailTagModal(false),
    });
  }

  const tabBarExtraContent = (
    <a href={`mailto:${getEmailHelp()}?subject=Company ${data?.name}`}>
      <Button type="text" className="help-btn">
        {Localize("COMMON.HELP")}
      </Button>
    </a>
  );

  const permissionScopes = get("scopes");
  const hasNielsenAccess = Object.keys(permissionScopes).some(
    (p) => p === "companyInvestment",
  );
  const hasBrandsAccess = Object.keys(permissionScopes).some(
    (p) => p === "companyBrand",
  );
  const hasPitchAccess = Object.keys(permissionScopes).some(
    (p) => p === "companyPitch",
  );
  const hasCreaAccess = Object.keys(permissionScopes).some(
    (p) => p === "creativities",
  );
  const isPitchRelevantType = ["ADV", "ME", "AG", "CP"].includes(data?.type);
  return (
    <div className="companyPage">
      {data && (
        <>
          <Helmet defer={false}>
            <title>{data.name} - Blinko</title>
          </Helmet>
          <CompanyHeader
            data={data}
            permissions={permissions}
            match={match}
            selectedAlerts={selectedAlerts}
            setSelectedAlerts={setSelectedAlerts}
          />
          <Col span={24} className="companyPage__body">
            <Tabs
              options={{
                activeKey: activeTab,
                defaultActiveKey: tabKeys.detail,
                onChange: (key) => setActiveTab(key),
                onTabClick: () => {
                  window.scrollTo({
                    behavior: "smooth",
                    left: 0,
                    top: 0,
                  });
                },
                animated: true,
                tabBarExtraContent,
              }}
            >
              <CompanyGeneral
                k={tabKeys.detail}
                title={Localize(
                  "PAGES.COMPANIES.DETAIL.SECTIONS.GENERAL.TITLE",
                )}
                data={data}
                entity={entity}
                schema={schema}
                features={features}
                permissions={permissions}
                match={match}
                sectorModal={sectorModal}
                info={info}
              />
              <div
                k={tabKeys.contacts}
                className="grey-light-color"
                title={Localize("PAGES.COMPANIES.DETAIL.SECTIONS.CONTACTS")}
              >
                <Row gutter={24} className="animation ">
                  <Col span={24} style={{ marginBottom: "30px" }} className="">
                    <CompanyContacts companyId={match.params.id} />
                  </Col>
                </Row>
              </div>
              <div
                k={tabKeys.financials}
                className="grey-light-color"
                title={Localize("PAGES.COMPANIES.DETAIL.SECTIONS.FINANCIALS")}
              >
                <Row gutter={24} className="animation">
                  <Col span={24}>
                    <CompanyFinancial
                      data={data.financial_history}
                      hasAccess={permissions.companyFinancials}
                    />
                  </Col>
                </Row>
              </div>
              <div
                k={tabKeys.investmentRounds}
                className="grey-light-color"
                title={Localize(
                  "PAGES.COMPANIES.DETAIL.SECTIONS.INVESTMENT_ROUND",
                )}
              >
                <Row gutter={24} className="animation">
                  <Col span={24}>
                    <CompanyInvestmentRound
                      companyId={match.params.id}
                      hasAccess={permissions.investmentRounds}
                    />
                  </Col>
                </Row>
              </div>
              <div
                k={tabKeys.nielsen}
                className="grey-light-color"
                title={Localize("PAGES.COMPANIES.DETAIL.SECTIONS.INVESTMENTS")}
              >
                <Row gutter={24} className="animation">
                  <Col
                    span={24}
                    style={{ marginBottom: "30px" }}
                    className="animation"
                  >
                    <CompanyInvestments
                      companyId={match.params.id}
                      hasAccess={hasNielsenAccess}
                    />
                  </Col>
                </Row>
              </div>
              <div
                k={tabKeys.brands}
                className="grey-light-color"
                title={Localize("PAGES.COMPANIES.DETAIL.SECTIONS.BRANDS")}
              >
                <Row gutter={24}>
                  <Col span={24} style={{ marginBottom: "30px" }}>
                    <CompanyBrands
                      companyId={match.params.id}
                      sectors={isAgency ? sector : data.sector}
                      isAgency={isAgency}
                      hasAccess={hasBrandsAccess}
                    />
                  </Col>
                </Row>
              </div>
              {isPitchRelevantType && (
                <div
                  className="grey-light-color"
                  title="Pitch"
                  k={tabKeys.pitch}
                >
                  <Row gutter={24}>
                    <Col span={24}>
                      <CompanyPitch
                        companyId={match.params.id}
                        companyName={data.name}
                        hasAccess={hasPitchAccess}
                      />
                    </Col>
                  </Row>
                </div>
              )}
              {isPitchRelevantType && (
                <div
                  k={tabKeys.crea}
                  className="grey-light-color"
                  title={Localize("PAGES.COMPANIES.DETAIL.SECTIONS.CREATIVITY")}
                >
                  <Row gutter={24}>
                    <Col span={24}>
                      <CompanyCrea
                        companyId={match.params.id}
                        hasAccess={hasCreaAccess}
                      />
                    </Col>
                  </Row>
                </div>
              )}
              <div
                className="grey-light-color"
                title={Localize("PAGES.COMPANIES.DETAIL.SECTIONS.GROUP")}
                k={tabKeys.group}
              >
                <Row gutter={24} className="animation ">
                  <Col span={24} style={{ marginBottom: "30px" }} className="">
                    <CompanyGroup
                      companyId={match.params.id}
                      companyName={data.name}
                    />
                  </Col>
                </Row>
              </div>
              <div
                className="grey-light-color"
                title={Localize("PAGES.PITCH_SCORES.TITLE")}
                k={tabKeys.pitchScores}
                key={tabKeys.pitchScores}
              >
                <Row gutter={24} className="animation ">
                  <Col span={24} style={{ marginBottom: "30px" }} className="">
                    <CompanyPitchScores
                      companyId={match.params.id}
                      hasAccess={permissions.pitchScores}
                    />
                  </Col>
                </Row>
              </div>
            </Tabs>
          </Col>
        </>
      )}
    </div>
  );
};

export default (props) => {
  return (
    <CompanyDetail
      key={`companyDetails_${props.match?.params?.id}`}
      {...props}
    />
  );
};
